module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAEeCAYAAACty7Q3AAAATElEQVRYR+3XwQkAIAwEQdOGJaUjq1cQg7YgTJ55HtklFz3HbM+EhTzuPTgHeLBDJYAGNKABDTsBMiADMiADMuBCpVlpVppPAv88RguWdRUF4IfkJQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/left_bottom_tbody_hr.png
// module id = VDPs
// module chunks = 0